import { Delete } from '@workwave-tidal/core/icons'
import { useCallback, useMemo } from 'react'

import { resetCrudSelection } from '@/atoms'
import { preview } from '@/components/form/preview'

import { DepotAvatar } from '../../../components/DepotAvatar'
import { useIsDepotLinkedToOrderSteps } from '../../../hooks/useIsDepotLinkedToOrderSteps'

import { useDeleteDepotModal } from '../../DeleteDepotModal'
import { useTexts } from '../hooks/useTexts'

type HeaderProps = {
  depots: uui.domain.client.rm.Depot[]
}

export function Header(props: HeaderProps) {
  const { depots } = props
  const texts = useTexts()
  const { Modal: DeleteDepotModal, show } = useDeleteDepotModal()

  const depotIds = useMemo(() => depots.map(depot => depot.id), [depots])

  const depotCannotDeDeleted = useIsDepotLinkedToOrderSteps(depotIds)

  const onReset = useCallback(() => {
    resetCrudSelection('depots')
  }, [])

  return (
    <preview.Header
      title={texts.title(depotIds.length)}
      testId="depot-view-header"
      avatar={<DepotAvatar depots={depots} size={44} />}
      onClose={onReset}
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Delete />}
          onClick={show}
          label={texts.delete.title}
          tooltip={texts.delete.tooltip(depotCannotDeDeleted, depotIds.length)}
          testId="setup-depot__delete-button"
          disableWhenReadOnly
          disabled={depotCannotDeDeleted}
        />
      </preview.ActionBar>

      <DeleteDepotModal depotIds={depotIds} />
    </preview.Header>
  )
}
